// 接口文档： https://supptech.sg.larksuite.com/docx/ZFNVdtpUioJZ0jxRmfTl5dzugQe

import {
  ReportAudit,
  ReportCategory,
  ReportDetail,
  ReportList,
  ReportListQuery,
} from '@/types/report';
import axiosInstance from './axiosInstance';
import { BaseResponse } from '@/types/common';

const baseUrl = `${SUPP_ADMIN_BASE_URL}/supp-management`;

export const getReportCategory = async (): Promise<
  BaseResponse<ReportCategory[]>
> => {
  const resp = await axiosInstance.get<BaseResponse<ReportCategory[]>>(
    `${baseUrl}/report/category`
  );
  return resp.data;
};

export const getReportList = async (
  query: ReportListQuery
): Promise<BaseResponse<ReportList>> => {
  const resp = await axiosInstance.post<BaseResponse<ReportList>>(
    `${baseUrl}/report/pageList`,
    query
  );
  return resp.data;
};

export const getReportDetail = async (
  reportId: number
): Promise<BaseResponse<ReportDetail>> => {
  const resp = await axiosInstance.get<BaseResponse<ReportDetail>>(
    `${baseUrl}/report/detail`,
    { params: { reportId } }
  );
  return resp.data;
};

export const auditReport = async (
  data: ReportAudit
): Promise<BaseResponse<null>> => {
  const resp = await axiosInstance.post<BaseResponse<null>>(
    `${baseUrl}/report/audit`,
    data
  );
  return resp.data;
};
